import React from "react";
import "./MyAccount.css";
import { FaUserCircle } from "react-icons/fa";
import { MdSupportAgent, MdCreditCard } from "react-icons/md";

export default function MyAccount({ onBack }) {
  return (
    <div className="account-page">
      {/* ===== Page Header ===== */}
      <header className="account-page__header">
        <button
          className="account-page__back-btn"
          onClick={onBack}
          aria-label="Go back"
        >
          <span className="account-page__back-arrow"></span>
        </button>
        <h2 className="account-page__title">My Account</h2>
      </header>
      <p className="account-page__subtitle">
        Manage profile and payment settings
      </p>
      <hr className="account-page__divider" />

      {/* ===== Subscription Settings ===== */}
      <section className="account-page__section">
        <h3 className="account-section__title">Subscription Settings</h3>
        <p className="account-section__description">
          View and manage your subscription status.
        </p>

        <div className="subscription-card">
          <div className="subscription-card__info">
            <div className="subscription-card__alert-icon">!</div>
            <div>
              <p className="subscription-card__alert-title">
                Your account is unverified and currently on the free plan.
              </p>
              <p className="subscription-card__alert-description">
                Upgrade to paid subscription plans for wider services and
                full-range use of CAT products.
              </p>
            </div>
          </div>

          <div className="subscription-card__actions">
            <button className="subscription-card__action subscription-card__action--primary">
              <MdSupportAgent className="subscription-card__action-icon" />{" "}
              Contact support
            </button>
            <button className="subscription-card__action subscription-card__action--secondary">
              <MdCreditCard className="subscription-card__action-icon" /> View
              plans
            </button>
          </div>
        </div>
      </section>

      <hr className="account-page__divider" />

      {/* ===== Identification Settings ===== */}
      <section className="account-page__section account-page__section--identification">
        <div className="account-section__intro">
          <h3 className="account-section__title">Identification Settings</h3>
          <p className="account-section__description">
            Make changes to your identification settings.
          </p>
        </div>

        <div className="identification-form">
          <div className="identification-form__row identification-form__row--single">
            <div className="identification-form__field">
              <label>Username</label>
              <input type="text" defaultValue="Sample Username" />
            </div>
          </div>

          <div className="identification-form__row identification-form__row--profile">
            <div className="identification-form__field">
              <label>Profile picture</label>
              <div className="profile-upload">
                <FaUserCircle className="profile-upload__icon" />
                <button className="profile-upload__button">
                  Upload a new photo
                </button>
              </div>
            </div>
          </div>

          <div className="identification-form__row">
            <div className="identification-form__field">
              <label>Email address</label>
              <input type="email" placeholder="Email address" />
            </div>
            <div className="identification-form__field">
              <label>Phone number</label>
              <input type="text" placeholder="Phone number" />
            </div>
          </div>

          <div className="identification-form__row">
            <div className="identification-form__field">
              <label>Affiliated organization/institution</label>
              <input
                type="text"
                placeholder="Affiliated Organization/Institution"
              />
            </div>
            <div className="identification-form__field">
              <label>Role/title</label>
              <input type="text" placeholder="Role or title" />
            </div>
          </div>
        </div>
      </section>

      <hr className="account-page__divider" />

      {/* ===== Delete Account ===== */}
      <section className="account-page__section">
        <h3 className="account-section__title">Delete Account</h3>
        <p className="account-section__description">
          If you no longer require uTECH’s services, you may permanently delete
          your account.
        </p>

        <div className="delete-card">
          <div className="delete-card__warning">
            <div className="delete-card__icon">!</div>
            <p className="delete-card__text">
              Deleting your account erases all uploaded files and relevant
              account information.<br />
              <span className="delete-card__supporting-text">
                If you wish to regain access to your account, contact an agent
                or uTECH support during available hours. More information{" "}
                <a href="#">here</a>.
              </span>
            </p>
          </div>
          <button className="delete-card__action">⚠ Delete my account</button>
        </div>
      </section>
    </div>
  );
}
